import { useEffect, useState } from "react";
import { useGlobalReducer } from "../../GlobalContext";
import { GetEntityAudits } from "../api/entityService";
import { convertDayFormatForMoment, getAuditLabel } from "../utils/utility";
import { convertUTCDateTimeToLocal } from "../blocks/fields/formatDate";
import { Loading } from "../elements/Loading";
import { EntityAuditModal } from "./EntityAuditModal";
import { Audit, EntityInformationProps } from "./EntityInformation.types";

const format = (date: string) =>
  convertUTCDateTimeToLocal(date)?.format(convertDayFormatForMoment("dd/MM/yyyy HH:mm:ss"));

/** A record's id and creation date, and its audit history, each audit opening in full. */
export function EntityInformation({ label, state }: EntityInformationProps) {
  const globalDispatch = useGlobalReducer();
  const [audits, setAudits] = useState<Audit[] | null>(null);
  const [loggingId, setLoggingId] = useState("");
  const { createdon, id } = state;

  useEffect(() => {
    let current = true;

    GetEntityAudits(globalDispatch, label, id)
      .then((response: { data?: Audit[] } | undefined) => {
        if (current && response?.data) {
          setAudits(response.data);
        }
      })
      .catch((error: unknown) => console.error("Error fetching audits:", error));

    return () => {
      current = false;
    };
  }, [globalDispatch, id, label]);

  return (
    <>
      <EntityAuditModal
        label={label}
        audits={audits ?? []}
        loggingId={loggingId}
        onClose={() => setLoggingId("")}
      />
      <div className="row">
        <div className="col-12 col-md-3 order-1 order-md-2">
          <div className="card">
            <div className="card-body">
              <p className="fw-bold m-0">Id</p>
              <p>{id}</p>
              <p className="fw-bold m-0">Created On</p>
              <p>{format(createdon)}</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-9 order-2 order-md-1">
          {!audits ? (
            <Loading />
          ) : (
            <div className="card">
              <div className="card-body">
                {audits.length > 0 ? (
                  audits.map((audit, index) => (
                    <div key={audit.LoggingId} className={index > 0 ? "mt-4" : undefined}>
                      <strong className="link-primary cursor-pointer" onClick={() => setLoggingId(audit.LoggingId)}>
                        {getAuditLabel(audit, false)}
                      </strong>
                      <p className="m-0">{format(audit.CreatedOn)}</p>
                    </div>
                  ))
                ) : (
                  <p>No audits found</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EntityInformation;
